module.exports = "../images/homepage-hero.jpg?v=4e70bf0";